<template>
  <el-dialog
  title=""
  :visible.sync="show"
  :before-close="close"
  center
  destroy-on-close>
    <el-form
    ref="form"
    :rules="rules"
    :model="info"
    label-width="20%">
      <el-form-item label="镇" prop="town">
        <el-input :disabled="type === 'details'" v-model="info.town"/>
      </el-form-item>
      <el-form-item label="村" prop="village">
        <el-input :disabled="type === 'details'" v-model="info.village"/>
      </el-form-item>
      <el-form-item label="邮政编码" prop="postcode">
        <el-input :disabled="type === 'details'" v-model="info.postcode"/>
      </el-form-item>
      <el-form-item
      v-for="(item, index) in info.nameList"
      :key="`nameList${index}`"
      :label="index === 0 ? '生产队' : ''"
      :prop="'nameList.' + index"
      :rules="{
        required: true, message: '请输入生产队名称', trigger: 'change'
      }"
      >
        <el-input :disabled="type === 'details'" v-model="info.nameList[index]" style="width: 70%"/>
        <div class="operate" v-if="type === 'new'">
          <i class="el-icon-circle-plus-outline" @click="addData"/>
          <i class="el-icon-remove-outline" @click="deleteData(index)" v-if="index > 0"/>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button v-if="type === 'details'" type="primary" @click="close()">关 闭</el-button>
        <el-button v-else type="primary" @click="editEventForm()">提 交</el-button>
      </div>
  </el-dialog>
</template>

<script>
import { teamBatchAdd, teamUpdate } from '@/api/community.js'
export default {
  data () {
    return {
      type: '',
      id: '',
      show: false,
      rules: {
        town: [{ required: true, message: '请输入镇', trigger: 'change' }],
        village: [{ required: true, message: '请输入村', trigger: 'change' }],
        postcode: [{ required: true, message: '请输入邮政编码', trigger: 'change' }],
      },
      info: {
        town: '',
        village: '',
        postcode: '',
        nameList: []
      }
    }
  },
  methods: {
    showDetails (type, info) {
      this.type = type
      this.show = true
      if (type !== 'new') {
        this.getDetails(info)
      } else {
        this.info.nameList = ['']
      }
    },
    addData () {
      this.info.nameList.push('')
    },
    deleteData (index) {
      this.info.nameList.splice(index, 1)
    },
    getDetails (info) {
      this.info = {
        town: '',
        village: '',
        postcode: '',
        nameList: [info?.name || ''],
        ...info
      }
    },
    editEventForm () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log(1111)
          let url = this.type === 'new' ? teamBatchAdd : teamUpdate
          let info = {
            ...this.info
          }
          if (this.type !== 'new') {
            info = {
              ...info,
              name: info.nameList[0]
            }
            delete info.nameList
          }
          const res = await url({ ...info })
          const { code } = res
          if (code === 0) {
            this.$emit('addSuccess')
            this.close()
          }
        }
      })
    },
    close () {
      this.show = false
      this.id = ''
      this.type = ''
      this.$nextTick(() => (
        this.info = {
          town: '',
          village: '',
          postcode: '',
          nameList: []
        }
      ))
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog{
  min-width: 450px;
  width: 30%;
}
.operate {
    display: inline-block;
    font-size: 24px;
    i {
      margin: 0 5px;
    }
  }
</style>